import { render, staticRenderFns } from "./teachingManage.vue?vue&type=template&id=5c56432f&scoped=true&"
import script from "./teachingManage.vue?vue&type=script&lang=js&"
export * from "./teachingManage.vue?vue&type=script&lang=js&"
import style0 from "./teachingManage.vue?vue&type=style&index=0&id=5c56432f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c56432f",
  null
  
)

export default component.exports